import gql from 'graphql-tag';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { graphql } from 'react-apollo';

const PATRON_ASSETS_QUERY = gql`
  query {
    patronAssets {
      tickets
      wscore
      nuggets
      rubies
      sapphires
      wchips
      gameBalance
    }
  }
`;

const SUBSCRIPTION_UPDATED_CURRENCY_ITEM_BALANCES = gql`
  subscription {
    updatedCurrencyItemBalances {
      wscoreBalance
      nuggetsBalance
      sapphiresBalance
      rubiesBalance
      wchipsBalance
      creditsBalance
    }
  }
`;

export default graphql(PATRON_ASSETS_QUERY, {
  name: 'assetsData',
  props: ({ ownProps, assetsData }) => ({
    assetsData,
    subscribeToWScoreData: () => {
      return assetsData.subscribeToMore({
        document: SUBSCRIPTION_UPDATED_CURRENCY_ITEM_BALANCES,
        updateQuery: (prev, { subscriptionData }) => {
          const {
            wscoreBalance,
            nuggetsBalance,
            sapphiresBalance,
            rubiesBalance,
            wchipsBalance,
            creditsBalance
          } = subscriptionData.data;

          let currencyItemBalances = {};
          if (!isNil(wscoreBalance)) {
            currencyItemBalances.wscore = wscoreBalance;
          }
          if (!isNil(nuggetsBalance)) {
            currencyItemBalances.nuggets = nuggetsBalance;
          }
          if (!isNil(sapphiresBalance)) {
            currencyItemBalances.sapphires = sapphiresBalance;
          }
          if (!isNil(rubiesBalance)) {
            currencyItemBalances.rubies = rubiesBalance;
          }
          if (!isNil(wchipsBalance)) {
            currencyItemBalances.wchips = wchipsBalance;
          }
          if (!isNil(creditsBalance)) {
            currencyItemBalances.gameBalance = creditsBalance;
          }

          if (!isEmpty(currencyItemBalances)) {
            return Object.assign({}, prev, {
              patronAssets: Object.assign(
                {},
                prev.patronAssets,
                currencyItemBalances
              )
            });
          } else {
            return null;
          }
        }
      });
    }
  })
});
